angular.module('CarsSaraBo').factory('AvailabilityService', ['$resource', 'FleetService', 'PointOfSaleService','$q', 'AlertEmailService',
	function ($resource, fleetService, pointOfSaleService, $q, alertEmailService) {
	return {
		resource: $resource('../rest/company/:companyOid/availability',
			{companyOid: '@companyOid'},
			{
				save: {method: 'POST'},
				update: {method: 'PUT'},
				remove: {method: 'DELETE'},
				get: {method: 'GET', isArray: true},
				getAvailability: {method: 'GET'}
			}
		),

		save: function (companyOid, carsStock, period, pos, days, contract) {
			// prepare request body
			var requestBody = createAvailability(carsStock, period, pos, days, contract);
			return this.resource.save({companyOid: companyOid}, requestBody).$promise;
		},

		getResources: function (companyOid) {
			var fieldsCar = "oid,name,carModel";
			var fieldAlert = "types";
			return $q.all([
				fleetService.get({companyOid: companyOid, fields: fieldsCar}).$promise,
				alertEmailService.query({companyOid: companyOid, fields: fieldAlert}).$promise,
				pointOfSaleService.resource.query({companyOid: companyOid}).$promise
			]);
		}
	}

	function createAvailability(carsStock, period, pos, days, contract) {
		var carsAvailability = {
			pointsOfSale: pos,
			daysOfWeek: days,
			period: {
				from: moment(period.from).format("YYYYMMDD"),
				to: moment(period.to).format("YYYYMMDD")
			},
			cars: carsStock,
			contractOid: contract
		};
		return carsAvailability;
	}
}]);


//////////////////
// WEBPACK FOOTER
// ./public/app/availability/availability_service.js
// module id = 932
// module chunks = 3